import { Component, Input } from '@angular/core';
import { TealCompReferralSubmission } from '../../../models/teal-comp-referral';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { CardModule } from 'primeng/card';
import { PanelModule } from 'primeng/panel';

@Component({
  selector: 'app-submission-viewer',
  standalone: true,
  imports: [NgIf,CardModule,NgFor,PanelModule, DatePipe],
  templateUrl: './submission-viewer.component.html',
  styleUrl: './submission-viewer.component.scss'
})
export class SubmissionViewerComponent 
{
  @Input() submission?: TealCompReferralSubmission;

  constructor()
  {
    console.log("Loading")
  }
}
